var _PoweredBy;
// IMPORTANT: DO NOT ERASE the commented code below, it will be used later on a next iteration

// import { useMemo } from 'react';

import PoweredBy from "../PoweredBy";

// biome-ignore lint/complexity/noBannedTypes: legacy type usage
import { jsx as _jsx } from "react/jsx-runtime";
var Logo = function Logo() {
  // const logoType = useMemo<CrehanaLogoType>(() => {
  //   if (user) {
  //     if (user.isB2B) {
  //       return 'b2b';
  //     }
  //     if (user.isActiveDegree) {
  //       return 'microdegree';
  //     }
  //     if (user.isPremium) {
  //       return 'premium';
  //     }
  //   }

  //   return 'default';
  // }, [user]);

  // const renderLogo = () => {
  //   if (logoType === 'b2b') {
  //     return <PoweredBy />;
  //   }

  //   if (logoType === 'premium') {
  //     return (
  //       <CrehanaPremium
  //         size={32}
  //         aria-hidden
  //         ignoreColor
  //         className="tw-fill-current tw-text-primary-light-500 dark:tw-text-neutral-light-100"
  //       />
  //     );
  //   }

  //   if (logoType === 'microdegree') {
  //     return (
  //       <CrehanaMicroDegree
  //         size={24}
  //         aria-hidden
  //         ignoreColor
  //         className="tw-fill-current tw-text-primary-light-500 dark:tw-text-neutral-light-100"
  //       />
  //     );
  //   }

  //   return (
  //     <Crehana
  //       size={16}
  //       aria-hidden
  //       ignoreColor
  //       className="tw-fill-current tw-text-primary-light-500 dark:tw-text-neutral-light-100"
  //     />
  //   );
  // };

  // if (urls && urls.home) {
  //   return (
  //     <a
  //       href={urls.home}
  //       target={targetLink}
  //       rel="noopener noreferrer"
  //       className="logo"
  //     >
  //       {renderLogo()}
  //     </a>
  //   );
  // }

  return _PoweredBy || (_PoweredBy = /*#__PURE__*/_jsx(PoweredBy, {}));
};
export default Logo;